<input
  #value
  matInput
  [formControl]="valueInputControl"
  (input)="handleInput($event)"
  (focus)="setOptionFilter($event)"
  (focusin)="onFocusIn()"
  (focusout)="onFocusOut()"
  [matAutocomplete]="autocomplete"
  [matAutocompleteConnectedTo]="autocompleteOrigin"
/>
<mat-autocomplete #autocomplete="matAutocomplete" requireSelection [displayWith]="getDisplayName" autoActiveFirstOption>
  <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option">
    {{ getDisplayName(option) }}
  </mat-option>
</mat-autocomplete>
